<template>
  <navigation>
    <router-view />
  </navigation>
</template>

<script>
export default {
  name: "App"
};
</script>
<!-- 路由问题解决时间过了一段时间再次访问就是白屏问题
<template>
  <router-view />
</template>

<script>
export default {
  name: "App"
};
</script> -->
